import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, flatMap, map, switchMap } from 'rxjs/operators';
import * as fromShared from '../../../../shared';
import { ResponseStatus } from '../../../../shared';
import { InvoiceManagementService } from '../../../management/invoice-management.service';
import * as InvoiceSessionNumberActions from './invoice-session-number.actions';

@Injectable()
export class InvoiceSessionNumberEffects {
    getInvoiceSessionNumbers$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(InvoiceSessionNumberActions.getInvoiceSessionNumbers),
            switchMap(action =>
                this.service
                    .getInvoiceSessions(
                        action.ScheduledStartDate,
                        action.ScheduledEndDate,
                        action.ContractListID,
                        action.ContractDesc,
                        // action.showInactive,
                        action.showInvoicesOnly,
                        action.DateRangeView
                    )
                    .pipe(
                        map(data =>
                            InvoiceSessionNumberActions.loadInvoiceSessionNumbers(
                                { invoiceSessionNumbers: data }
                            )
                        ),
                        // retryBackoff({ initialInterval: 3000, maxRetries: 3 }),
                        catchError(fromShared.Errors.handleServiceError)
                    )
            )
        );
    });
    putInvoiceSessionNumbers$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(InvoiceSessionNumberActions.putInvoiceSessionNumbers),
            switchMap(action =>
                this.service.putInvoiceSessions(action.sessions).pipe(
                    map(resp =>
                        InvoiceSessionNumberActions.upsertInvoiceSessionNumbers(
                            { invoiceSessionNumbers: resp.Items }
                        )
                    ),
                    // retryBackoff({ initialInterval: 3000, maxRetries: 3 }),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
    removeInvoiceSessions$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(InvoiceSessionNumberActions.removeInvoiceSessionNumbers),
            switchMap(a =>
                this.service.deleteInvoiceSessions(a.ids).pipe(
                    flatMap(resp => {
                        const success =
                            fromShared.Errors.IsSuccessStatus(resp.StatusCode);
                        if (!success) {
                            return [
                                new fromShared.Errors.SetErrors(
                                    fromShared.Errors.MapErrorsToStatus(resp)
                                )
                            ];
                        }
                        const actions = [
                            InvoiceSessionNumberActions.deleteInvoiceSessionNumbers(
                                { ids: a.ids }
                            )
                        ] as const;
                        if (a.refetchFilter) {
                            return [
                                ...actions,
                                InvoiceSessionNumberActions.getInvoiceSessionNumbers(
                                    a.refetchFilter
                                )
                            ];
                        }
                        return actions;
                    }),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
    constructor(
        private actions$: Actions,
        private service: InvoiceManagementService
    ) {}
}
